
//解析url参数
function getURLQuery(key) {
    var url = decodeURI(location.search); //获取url中"?"符后的字串
    var theRequest = new Object();
    if (url.indexOf("?") != -1) {
        var str = url.substr(1);
        var strs = str.split("&");
        for (var i = 0; i < strs.length; i++) {
            theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
        }
    }
    return theRequest[key];
}

// 判断是否是pc端
function isPC() {
  var ua = window.navigator.userAgent
  if (ua.match(/Android/i)
    || ua.match(/webOS/i)
    || ua.match(/iPhone/i)
    || ua.match(/iPad/i)
    || ua.match(/iPod/i)
    || ua.match(/BlackBerry/i)
    || ua.match(/Windows Phone/i)) {
    return false
  } else {
    return true
  }
}

// 显示 loading 加载图标
function showLoadingImg (bool) {
  if (bool) {
    let loadingImg = '<div class="loading-gif"></div>'
    $('#app > div').append(loadingImg)
  } else {
    $('.loading-gif').remove()
  }
}

// 在微信中提示在浏览器中打开
function showWxModal () {
  let wxModal = '<div class="wx-modal"></div>'
  $('#app > div').append(wxModal)
  $('.wx-modal').click(function() {
    $(this).hide()
  })
}

// 弹出提示信息
function popMessage (param) {
  let mes = param ? param : '敬请期待'
  let message = '<div class="pop-message">' + mes + '</div>'
  $('#app > div').append(message)
  setTimeout(() => {
    $('.pop-message').remove()
  }, 2000)
}

// 拉起游戏/下载
import addClientEvent from "./addClientEvent";
function pullGame (gameId, portrait) {
  let channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
  let channelQuery = channel ? '?channel=' + channel : ''
  let ua = window.navigator.userAgent.toLowerCase() || '';
  let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('linux') > -1; // 安卓

  if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/QQ\//i) == "qq/" || ua.match(/WeiBo/i) == "weibo") {
    //微信
    _hmt.push(['_trackEvent', 'miguplay App', '下载', '咪咕游戏官网 - 微信' + ' - ' + channel])
    showWxModal()
  } else {
    // iOS
    if (!isAndroid) {
      _hmt.push(['_trackEvent', 'miguplay App', '下载', '咪咕游戏官网 - IOS' + ' - ' + channel])
      var schema = "https://beta.migufun.com/migugameuniversallink/" + channelQuery
      if (gameId) {
        let channelQuery2 = channel ? '&channel=' + channel : ''
        if (typeof(portrait) != 'undefined') {
          let portraitQuery = '&portrait=' + portrait
          schema = "https://beta.migufun.com/migugameuniversallink/gameplay?gameid=" + gameId + "&gametype=1" + portraitQuery + channelQuery2
        } else {
          schema = "https://beta.migufun.com/migugameuniversallink/gamedetail?gameid=" + gameId + "&gametype=1" + channelQuery2
        }
      }
      window.location.href = schema
    } else {
      // 安卓
      _hmt.push(['_trackEvent', 'miguplay App', '下载', '咪咕游戏官网 - 安卓' + ' - ' + channel])
      showLoadingImg(true)
      var schema = "youplay://"
      if (gameId) {
        if (typeof(portrait) != 'undefined') {
          let portraitQuery = '&portrait=' + portrait
          schema = "youplay://cloudGamePlay?gameid=" + gameId + "&gametype=1" + portraitQuery
        } else {
          schema = "youplay://gamedetail?gameid=" + gameId + "&gametype=1"
        }
      }
      window.location.href = schema

      // 拉起失败，跳到下载宣传页
      var statue = false
      var count = 1
      var inter = null
      inter = window.setInterval(function() {
        count++
        statue = document.hidden || document.webkitHidden
        if (statue || count > 50) {
          if(!statue) window.location.href = 'http://g.10086.cn/h5/cloudgame/appdownload/appDownload.html' + channelQuery
          showLoadingImg(false)
          window.clearInterval(inter)
        }
      }, 100)
    }
  }
  let recordData = {
    "eventType": 'h5_floatlayer_0',
    "pageName": '底部浮层',
    "rese8": '点击 底部浮层-下载',
  }
  addClientEvent.recordEventAction(recordData)
}

import API from "../api/api";
// 拉起游戏/下载
function downloadGame (pageName, gameId) {
  let channel = MG.utils.getQueryString('channel') ? MG.utils.getQueryString('channel') : ''
  let channelQuery = channel ? '?channel=' + channel : ''
  let ua = window.navigator.userAgent.toLowerCase() || '';
  let isAndroid = ua.indexOf('android') > -1 || ua.indexOf('linux') > -1; // 安卓
  let isPc = isPC() // pc

  if (ua.match(/MicroMessenger/i) == "micromessenger" || ua.match(/QQ\//i) == "qq/" || ua.match(/WeiBo/i) == "weibo") {
    //微信
    _hmt.push(['_trackEvent', '游戏-' + pageName, '下载', '微信' + ' - ' + channel])
    showWxModal()
  } else if (isAndroid) {
    // 安卓
    _hmt.push(['_trackEvent', '游戏-' + pageName, '下载', '安卓' + ' - ' + channel])
    showLoadingImg(true)
    var schema = "youplay://"
    if (gameId) {
      schema = "youplay://gamedetail?gameid=" + gameId + "&gametype=1"
    }
    window.location.href = schema

    let param = {
      data: {
        'pageSymbol': channel
      }
    }
    API.getAppUrl(param, channel).then(resp => {
      if (resp.data.returnCode == '000000') {
        // 拉起失败，跳到下载宣传页
        var statue = false
        var count = 1
        var inter = null
        inter = window.setInterval(function() {
          count++
          statue = document.hidden || document.webkitHidden
          if (statue || count > 50) {
            if(!statue) window.location.href = resp.data.resultData.downLoadUrl
            showLoadingImg(false)
            window.clearInterval(inter)
          }
        }, 100)
      } else {
          // 提示部分
          popMessage()
          if (data.returnCode == '020041') {
            console.log("当前访问的下载包已经被停用")
          } else if (data.returnCode == '020042') {
            console.log("没有找到最新通用安装包地址")
          } else if (data.returnCode == '990001') {
            console.log("服务器内部错误")
          }
        }
    });
  } else if (isPc) {
    // pc
    _hmt.push(['_trackEvent', '游戏-' + pageName, '下载', 'pc模式' + ' - ' + channel])
    showLoadingImg(true)
    let param = {
      data: {
        'pageSymbol': channel
      }
    }
    API.getAppUrl(param, channel).then(resp => {
      if (resp.data.returnCode == '000000') {
        showLoadingImg(false)
        window.location.href = resp.data.resultData.downLoadUrl
      } else {
        // 提示部分
        popMessage()
        if (data.returnCode == '020041') {
          console.log("当前访问的下载包已经被停用")
        } else if (data.returnCode == '020042') {
          console.log("没有找到最新通用安装包地址")
        } else if (data.returnCode == '990001') {
          console.log("服务器内部错误")
        }
      }
    });
  } else {
    // iOS
    _hmt.push(['_trackEvent', '游戏-' + pageName, '下载', 'IOS' + ' - ' + channel])
    var schema = "https://beta.migufun.com/migugameuniversallink/" + channelQuery
    if (gameId) {
      let channelQuery2 = channel ? '&channel=' + channel : ''
      schema = "https://beta.migufun.com/migugameuniversallink/gamedetail?gameid=" + gameId + "&gametype=1" + channelQuery2
    }
    window.location.href = schema
  }
}

function autoAddEllipsis(pStr, pLen) {

  var _ret = cutString(pStr, pLen);
  var _cutFlag = _ret.cutflag;
  var _cutStringn = _ret.cutstring;

  if ("1" == _cutFlag) {
      return _cutStringn + "...";
  } else {
      return _cutStringn;
  }
}

function cutString(pStr, pLen) {

  // 原字符串长度
  var _strLen = pStr.length;

  var _tmpCode;

  var _cutString;

  // 默认情况下，返回的字符串是原字符串的一部分
  var _cutFlag = "1";

  var _lenCount = 0;

  var _ret = false;

  if (_strLen <= pLen / 2) {
      _cutString = pStr;
      _ret = true;
  }

  if (!_ret) {
      for (var i = 0; i < _strLen ; i++) {
          if (isFull(pStr.charAt(i))) {
              _lenCount += 2;
          } else {
              _lenCount += 1;
          }

          if (_lenCount > pLen) {
              _cutString = pStr.substring(0, i);
              _ret = true;
              break;
          } else if (_lenCount == pLen) {
              _cutString = pStr.substring(0, i + 1);
              _ret = true;
              break;
          }
      }
  }

  if (!_ret) {
      _cutString = pStr;
      _ret = true;
  }

  if (_cutString.length == _strLen) {
      _cutFlag = "0";
  }

  return { "cutstring": _cutString, "cutflag": _cutFlag };
}

/*
* 判断是否为全角
*
* pChar:长度为1的字符串
* return: true:全角
*          false:半角
*/
function isFull(pChar) {
  if ((pChar.charCodeAt(0) > 128)) {
      return true;
  } else {
      return false;
  }
}


module.exports = {
  getURLQuery: getURLQuery,
  pullGame: pullGame,
  showWxModal: showWxModal,
  showLoadingImg: showLoadingImg,
  popMessage: popMessage,
  downloadGame: downloadGame,
  autoAddEllipsis: autoAddEllipsis
}



// WEBPACK FOOTER //
// ./src/api/utils.js